import { MdRefresh, MdAutoAwesome, MdPsychology, MdInsertChart, MdLogout } from 'react-icons/md';
import { useAdvisor } from '../context/AdvisorContext';
import { logout } from '../auth';

// Small floating panel (bottom-right) with three demo-friendly memory
// actions. Always visible — easy to remove for production by deleting this
// component's import in App.js.
export default function DemoControls() {
  const ctx = useAdvisor();
  const isReturning = ctx.isReturningUser;

  const handleReset = () => {
    if (window.confirm('Reset persistent memory and reload? You will land on the cold-start onboarding flow.')) {
      ctx.resetMemory();
      // Soft reload so all components rebind to the cleared state.
      window.location.href = '/';
    }
  };

  const handleSeed = () => {
    ctx.seedMemory();
    // Soft reload so the welcome-back path triggers cleanly.
    window.location.href = '/';
  };

  return (
    <div className="demo-controls" role="group" aria-label="Demo controls">
      <span className="demo-controls__label">Demo</span>
      <button
        className="demo-controls__btn"
        onClick={handleReset}
        title="Clear persistent memory and reload (cold-start workflow)"
        type="button"
      >
        <MdRefresh size={14} /> Reset
      </button>
      <button
        className="demo-controls__btn"
        onClick={handleSeed}
        title="Seed yesterday's session and reload (day-after workflow)"
        type="button"
      >
        <MdAutoAwesome size={14} /> Seed
      </button>
      <button
        className={`demo-controls__btn ${isReturning ? 'demo-controls__btn--active' : ''}`}
        onClick={ctx.openMemoryView}
        disabled={!isReturning}
        title={isReturning ? 'View what the AI remembers' : 'No memory yet — interact with the app or click Seed'}
        type="button"
      >
        <MdPsychology size={14} /> Memory
      </button>
      <button
        className="demo-controls__btn"
        onClick={ctx.openMetricsView}
        title="Show landing-page signup totals + masked email list"
        type="button"
      >
        <MdInsertChart size={14} /> Metrics
      </button>
      <button
        className="demo-controls__btn demo-controls__btn--logout"
        onClick={logout}
        title="Sign out and return to the login screen"
        type="button"
      >
        <MdLogout size={14} /> Sign out
      </button>
    </div>
  );
}
